import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BiCartAdd, BiCartDownload } from "react-icons/bi";
import { ProductContext } from "../../Contexts/ProductContext";
import { addRemoveProductToCart, isProductInCart } from "../../Utils/cartUtils.jsx";
import "./ProductCardStyle.css";
import { CartOperation, IMAGE_URL } from "../../Utils/constant.js";
import NO_IMAGE from "../../Assets/no_img.jpg";
import { isEmpty } from "../../Utils/utils.js";
import PriceTag from "../global/PriceTag.jsx";
import { AuthContext } from "../../Contexts/AuthContext.jsx";
import { motion } from "framer-motion";


const NewlyUploadedProduct = ({ product }) => {
    const { productState, productDispatch, orderState, orderDispatch } = useContext(ProductContext);
    const { authState } = useContext(AuthContext);
    const navigate = useNavigate();
    const [cartBtnDisabled, setCartBtnDisabled] = useState(false);
    const isLogged = authState?.mobile?.length > 0;

    const addToCartHandler = (product) => {
        if (isLogged) {
            if (isProductInCart(productState?.cartIds, product?.prdId)) {
                navigate("/cart");
            } else {
                addRemoveProductToCart(
                    product,
                    productDispatch,
                    authState?.mobile,
                    CartOperation.add,
                    setCartBtnDisabled,
                    productState?.cart
                    , orderState, orderDispatch
                );
            }
        } else {
            navigate("/login");
        }
    };

    return (
        <>
            <motion.div animate={{ y: [0, -8, 0] }}
                whileHover={{ rotate: -2, scale: 1.02 }}
                transition={{
                    y: { duration: 1.8, repeat: Infinity, ease: "easeInOut" },
                    rotate: { type: "spring", stiffness: 300, damping: 20 },
                    scale: { type: "spring", stiffness: 300, damping: 20 }
                }} className="product-card">
                <div
                    className="product-card-img"
                    onPointerDown={() => navigate("/view/products", { state: { inventory: product } })}
                >
                    {
                        isEmpty(product.firstImage) ? (
                            <img src={NO_IMAGE} alt="No Image" width="250px" />
                        ) : <img src={`${IMAGE_URL}${product.firstImage}`} alt={product.name} width="250px" />
                    }
                </div>
                <div className="product-body">
                    <div className="product-brand-review">
                        <p className="product-brand">{product.brand}</p>
                    </div>
                    <h3 className="product-name" onPointerDown={() => navigate("/view/products", { state: { inventory: product } })}>{product.name}</h3>
                    {/* <p>{product._id}</p> */}
                    <PriceTag product={product} />

                    <button
                        className={`product-cart-btn pc-center ${cartBtnDisabled && "cart-disabled"
                            }`}
                        onClick={() => addToCartHandler(product)}
                        disabled={cartBtnDisabled}
                    >
                        {isProductInCart(productState?.cartIds, product?.prdId) ? (
                            <p className="pc-center">
                                <BiCartDownload className="cartIcon" /> Go To Cart
                            </p>
                        ) : (
                            <p className="pc-center">
                                <BiCartAdd className="cartIcon" />
                                Add To Cart
                            </p>
                        )}
                    </button>
                    <p className="product-date">
                        Updated on {product.on}
                    </p>
                </div>
            </motion.div>
        </>
    );
};
export { NewlyUploadedProduct };
